﻿import window from 'window';

export const signInLink = () => {

    const init = (link) => {	        
        const getLoginPageUrl = () => {
            const href = link.getAttribute('href');	
            return href.indexOf('redirectUrl') > 0 ? href.split('?')[0] : href;
        }
        
        link.addEventListener('click', () => {
            const loginPageUrl = getLoginPageUrl();
            
            const currentPageUrl = window.location.pathname + window.location.search;
            const redirectParameter = `redirectUrl=${encodeURIComponent(currentPageUrl)}`;
            
            const separator = loginPageUrl.indexOf('?') < 0 ? '?' : '&';
            const newUrl = `${loginPageUrl}${separator}${redirectParameter}`;

            link.setAttribute('href', newUrl);
        });
    };

    return {
        init: init,
        selector: '[data-component="sign-in-link"]'
    };
};
